import { render } from "./Modulo_ModuPlan.vue?vue&type=template&id=e2d0e21c"
import script from "./Modulo_ModuPlan.vue?vue&type=script&lang=js"
export * from "./Modulo_ModuPlan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__